import { createSelector } from 'reselect'

import { selectSiteBuilderState } from 'core-components/sitebuilder/store/selectors/selectSitebuilderSelectors'

export const selectAppOwnerId = createSelector([selectSiteBuilderState], ({ app }) => app.ownerId)
